import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const accordions = [
    {
        title: 'Dry Bar Hire',
        content: 'Why not book a dry bar hire and supply your drinks yourself? At Mobile Bar Hire, you can utilizeour dry bar hire services and save on costs while still ensuring a great night. Simply book a dry bar hire and add the alcohol that you wish for your personal bar hire!'
    },
    {
        title: 'Keg Hire',
        content: "If you're having a house party and don't want to bother with bar hire, why not book keg hire instead? We offer some fantastic prices for kegs according to your requirements. Choose from our range of draught beers, ciders and ales and get ready for a great night with your friends."
    },
    {
        title: 'Bartender Hire',
        content: "At Mobile Bar Hire, we don't just provide the bars we provide excellent bartenders as well! Book a bartender with us to add glamour to your event. All our staff are trained in customer service and are some of the finest in the industry. Whether you're looking for a cocktail flairer or a mixologist, we have bar staff and specialised bar staff to make sure your event is as memorable as ever!"
    },
    {
        title: 'Drink Hire',
        content: "This is a service provided with most or our mobile bar hire packages. At Mobile Bar Hire, when you book a portable bar hire, you also have the choice to have us equip your drinks with a customised drinks hire. We make sure there's a drink for everyone with our alcoholic and non-alcoholic drink choices. Don't bother with the hassle of purchasing your drinks, let us take care of it all. From draught beers, wines and spirits to the non-alcoholic beverages and sundries we will take care of all the details so you can mingle and enjoy the event with your guests. Contact Mobile Bar Hire to enquire about our services and get ready to host a truly spectacular event."
    },
    {
        title: 'Private Bar Hire',
        content: "With our range of bar and bar counter models, Mobile Bar Hire is the one-stop shop for private hire parties. From cocktail bars to traditional bars for a more intimate family gathering, look no further than Mobile Bar Hire for the ideal bar hire. Why bother with the hassles of sorting out your own bar when we can do it for you at some of the industry's most competitive rates?"
    },
    {
        title: 'Corporate Bar Hire',
        content: "With our exclusive range of corporate bar models, planning a corporate event has never been easier. Whether you need a bar hire for an exhibition or trade show, a company event or a conference. As specialists in the industry, we will take care of all the details including branding, promotional items onthe bar counter and a personalised drinks menu."
    },
    {
        title: 'Wedding Bar Hire',
        content: "Every wedding needs a unique edge that helps it stand out from the crowd. What better way than with a mobile bar hire? Our portable bars can be set up anywhere whether it's a marquee or outdoors! We provide a range of options for our customers from a free bar hire, cash bar hire to a bar hire with a set limit after which guests need to pay for their drinks. Why not book an LED cocktail bar hire now to add sparkle to your wedding!"
    },
    {
        title: 'Themed Events',
        content: "Whether it's a Halloween party, a fun fair or a themed cultural event, a portable bar hire from Mobile Bar Hire is the perfect choice. Our mobile bar hires can be decorated according to your theme to make sure your guests enjoy the event to the fullest. We can also provide staff who are uniformed according to the theme and also tailor a bespoke drinks menu in keeping with your event."
    },
    {
        title: 'Festivals',
        content: "Whether it's a music festival or a food festival, Mobile Bar Hire is here to add pizazz to your event. We cater to a range of festivals and outdoor events with suitable mobile bar hire to keep your guests entertained through the night. Our range of portable bar hires can be set up anywhere whether it's backstage for the performers or in trailers. We provide a customised bar hire and drinks hire service that takes away the stress when planning outdoor events."
    }
]
export default function AccordionUsage() {
    return (
        <div className="mb-6">
            {
                accordions.map((accordion, idx) => (
                    <Accordion className="mb-2" key={accordion.title}
                        sx={{
                            backgroundColor: '#eeeeee',
                            '& .Mui-expanded': {
                                backgroundColor: 'secondary.main',
                                color: 'secondary.contrastText'
                            }
                        }}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls={`${idx}-panel-content`}
                        >
                            <Typography className="fs-16 fw-semi-bold" component="span">{accordion.title}</Typography>
                        </AccordionSummary>
                        <AccordionDetails className="fs-14">
                            {accordion.content}
                        </AccordionDetails>
                    </Accordion>
                ))
            }
        </div>
    );
}